import React, {useState,useEffect } from "react";
import axios from "axios";
import { Button, TextField, Typography, Container } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import "../style/login.scss";

function UpdatePassword({role}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [username, setUsername] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const isOnet = role === "onet";
  const isCompass = role === "compass";

    useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) setUsername(storedUsername);
    }, []); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(newPassword.localeCompare(confirmPassword) !== 0){
      setError("Mots de passe non identiques")
    }
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(process.env.REACT_APP_DOMAIN_URL+"/userUpdate", {
        username,
        currentPassword,
        newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
      if (response.status === 200) {
        setSuccess("Mot de passe modifié avec succès !");
        setTimeout(() => navigate("/login"), 3000);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.error || "Erreur de connexion au serveur");
      } else {
        setError("Erreur de connexion au serveur");
      }
    }
  };


  console.log("Role actuel :", role === "onet");
  return (
      <Container component="main" maxWidth="xs" className="logContainer">
        <div className="logContainerChild">
          <LockOutlinedIcon sx={{ color: theme.palette.mode === 'dark' ? 'white' : 'black', fontSize: 30 }} />
          <Typography component="h1" variant="h5">
            Changer votre mot de passe
          </Typography>
          {error && <p className="error-message">{error}</p>}
          {success && <p style={{ color: "green" }}>{success}</p>}
          <form onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Mot de passe actuel"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={(e) => setCurrentPassword(e.target.value)}
              sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: isOnet ? '#06305C' : isCompass ? '#C4AC66' : '#F7E900',
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: isOnet ? '#06305C' : isCompass ? '#C4AC66' : '#F7E900',
                    },
                  },
                }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Nouveau mot de passe"
              type="password"
              id="password"
              onChange={(e) => setNewPassword(e.target.value)}
              sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: isOnet ? '#06305C' : isCompass ? '#C4AC66' : '#F7E900',
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: isOnet ? '#06305C' : isCompass ? '#C4AC66' : '#F7E900',
                    },
                  },
                }}
            />

            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Confirmer le nouveau mot de passe"
              type="password"
              id="password"
              onChange={(e) => setConfirmPassword(e.target.value)}
               sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: isOnet ? '#06305C' : isCompass ? '#C4AC66' : '#F7E900',
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: isOnet ? '#06305C' : isCompass ? '#C4AC66' : '#F7E900',
                    },
                  },
                }}
            />
          <Button
            type="submit"
            fullWidth
            sx={{
              mt: 3,
              backgroundColor: isOnet ? '#06305C' : isCompass ? '#C4AC66' : '#F7E900',
              color: isOnet ? 'white' : isCompass ? 'white' : 'black',
              '&:hover': {
              backgroundColor: isOnet ? '#06305C' : isCompass ? '#C4AC66' :'#F7E900',
            },
            }}
          >
            Modifier le mot de passe
          </Button>
          </form>
        </div>
      </Container>
  );
}

export default UpdatePassword;
